"use client"

import { StatusCell } from "@/components/data-views"
import { LeoSpottedTablePopover } from "@/components/question-quality/leo-spotted-table-popover"
import {
  LIBRARY_AI_SPOTTED_LABEL,
  LIBRARY_AI_SPOTTED_PRESENTATION,
  type LibraryAiSpotted,
} from "@/lib/library-ai-spotted"
import type { LeoSpottedSubject } from "@/lib/question-quality/leo-spotted-source"

/** AI Spotted tag with Leo spotted cards on the info icon. */
export function AiSpottedMark({
  subject,
  tag,
  why: _why,
  ask: _ask,
  stopRowClick = false,
  tipContentClassName,
  onOpenSheet,
}: {
  subject: LeoSpottedSubject
  tag: LibraryAiSpotted
  why: string
  ask: string
  stopRowClick?: boolean
  tipContentClassName?: string
  onOpenSheet?: () => void
}) {
  const presentation = LIBRARY_AI_SPOTTED_PRESENTATION[tag]
  const label = LIBRARY_AI_SPOTTED_LABEL[tag]

  return (
    <span className="inline-flex max-w-full items-center gap-1">
      <StatusCell label={label} tone={presentation.tone} icon={presentation.icon} />
      <LeoSpottedTablePopover
        subject={subject}
        stopRowClick={stopRowClick}
        tipContentClassName={tipContentClassName}
        onOpenSheet={onOpenSheet}
      />
    </span>
  )
}
